/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { SearchSentencesResponseItem } from './SearchSentencesResponseItem.js';
import {
    SearchSentencesResponseItemFromJSON,
    SearchSentencesResponseItemFromJSONTyped,
    SearchSentencesResponseItemToJSON,
} from './SearchSentencesResponseItem.js';

/**
 * 
 * @export
 * @interface SearchSentencesResponse
 */
export interface SearchSentencesResponse {
    /**
     * 
     * @type {Array<SearchSentencesResponseItem>}
     * @memberof SearchSentencesResponse
     */
    data?: Array<SearchSentencesResponseItem>;
    /**
     * 
     * @type {number}
     * @memberof SearchSentencesResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchSentencesResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchSentencesResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof SearchSentencesResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the SearchSentencesResponse interface.
 */
export function instanceOfSearchSentencesResponse(value: object): boolean {
    return true;
}

export function SearchSentencesResponseFromJSON(json: any): SearchSentencesResponse {
    return SearchSentencesResponseFromJSONTyped(json, false);
}

export function SearchSentencesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSentencesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(SearchSentencesResponseItemFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function SearchSentencesResponseToJSON(value?: SearchSentencesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(SearchSentencesResponseItemToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

